$(document).ready(function(){
$('.ast_featured.multiple-items').slick({
  infinite: false,
  arrows: true,
  dots: true,
  nextArrow: '<button class="slide-arrow next-arrow"><svg class="chevron--right" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M9 18.7913L15 12.7913L9 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',  
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M15 18.7913L9 12.7913L15 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$(window).scroll(function(){ 
if ($('.ast_related.multiple-item').length) {
   
 if ($('.ast_related.multiple-item.slick-initialized.slick-slider').length) {} else {
   
  $(".ast_related.multiple-item").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
  arrows: true,
  dots: false,
  nextArrow: '<button class="slide-arrow next-arrow"><svg class="chevron--right" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M9 18.7913L15 12.7913L9 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',  
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M15 18.7913L9 12.7913L15 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
   } 
 }
 });

$('.ast_block.multiple-block_items').slick({
  infinite: false,
  arrows: true,
  dots: true,
  nextArrow: '<button class="slide-arrow next-arrow"><svg class="chevron--right" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M9 18.7913L15 12.7913L9 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',  
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M15 18.7913L9 12.7913L15 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
  slidesToShow: 4,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        adaptiveHeight: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        adaptiveHeight: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});  

$(".product .product-form__input.ast_product_variants_1 .ast_swatch_img").hover(function(){
  var name = $(this).attr('data-value-title');
  $('.product-form__input.ast_product_variants_1 label.form__label .selected__value').text('(' + name +')');
});
$(".product .product-form__input.ast_product_variants_2 .ast_swatch_img").hover(function(){
  var name = $(this).attr('data-value-title');
  $('.product-form__input.ast_product_variants_2 label.form__label .selected__value').text('(' + name +')');
}); 
$(".product .product-form__input.ast_product_variants_3 .ast_swatch_img").hover(function(){
  var name = $(this).attr('data-value-title');
  $('.product-form__input.ast_product_variants_3 label.form__label .selected__value').text('(' + name +')');
});    

$(".product .product-form__input .ast_swatch_img").hover(function(){
  var name = $(".product__media-item.grid__item.slider__slide.is-active" ).attr('data-alt');
   console.log(name);
});

$(".ast_mega_menu .mega-menu__content-inner .mega-menu__list .ast-mega-menu__list").hover(function () {
    var data_title = $(this).attr("data-title");
    console.log(data_title);
    $(".ctm_menu_collection_data").each(function () {
      var data_value = $(this).attr("data-value");
      if (data_title == data_value) {
        $(this).css("display", "block");
      } else {
        $(this).css("display", "none");
      }
    });
  });

 $(".dropdown__menu-item .ast-sub-menu__list").hover(function () {
    var data_title = $(this).attr("data-title");
    console.log(data_title);
      $(".ctm_submenu_collection_data").each(function () {
      var data_value = $(this).attr("data-value");
      if (data_title == data_value) {
        $(this).css("display", "block");
      } else {
        $(this).css("display", "none");
      }
    });
  }); 
});  


$(document).on('click', '.ast_filter', function(){
  $('.mobile-facets__details').show();
  $('.mobile-facets__details.sort_by').hide();
});
$(document).on('click', '.ast_sort', function(){
  $('.mobile-facets__details').hide();
   $('.ast_Style, .ast_Intention, .ast_Material').hide();
  $('.mobile-facets__details.sort_by').show();
})


$(document).ready(function(){
 $(".non-product span").click(function(){
       $(this).parents('.grid__item').find('.custom_drawer_sec').addClass('right');  
       $(this).parents('.grid__item').find('.non-product-drawer-overlay').addClass('non-product-drawer-overlay-two');   
        $('body').css("overflow", "hidden");  
  });
$(".non-product-drawer-close").click(function(){
        $('.custom_drawer_sec').removeClass('right');  
       $('.non-product-drawer-overlay').removeClass('non-product-drawer-overlay-two');     
         $('body').css("overflow", "unset");  
  });
   });


  $(".ItgMediaAlt.product__media-item").each(function () {
     var data = $(this).attr("data-alt");
    console.log(data);
  });

  $('.product__media-list .product__media-item[data-alt]').hide();

  var getSelectAlt = $(".product__media-list .product__media-item.is-active" ).attr('data-alt');
  $('.product__media-list .product__media-item[data-alt="'+getSelectAlt+'"]').show();


if ($(document).find('.product__media-list > li').length) {

  $(document).find('.product__media-list > li').each(function() {
      if (!$(this).hasClass('ItgMediaAlt')) {
        $(this).show();
      }
  });
  
}

$('.facets__label > input').each(function(index) {
        var inputId = $(this).attr('id');
        inputId = inputId + '-' + (index + 1);
        console.log(inputId);
  $(this).parents('label').attr('for', inputId);
        $(this).attr('id', inputId);
    });

const SwymCheckFilterVal = () => {
  $('#FacetsWrapperDesktop details').each(function() {
    if ( $(this).find('.facets__list.list-unstyled').html() == "") {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  $('#FacetFiltersFormMobile details').each(function() {
    if ( $(this).find('.facets__list.list-unstyled').html() == "") {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
}
setTimeout(function() {
  SwymCheckFilterVal();
},500)
$(window).on('load', function() {
  SwymCheckFilterVal();
});

$(document).on('click', '.itg_header-icon .itg_header-icon-left', function(){
   $(this).parents('.ast_headermain').find('.cstm-header-search').addClass('left'); 
   $(this).parents('.ast_headermain').find('.cstm-header-search-overlay').addClass('cstm-header-search-overlay-two');   
        $('body').css("overflow", "hidden");  
});
$(".cstm-search-drawer-close").click(function(){
        $('.cstm-header-search').removeClass('left');  
         $('.cstm-header-search-overlay').removeClass('cstm-header-search-overlay-two');     
         $('body').css("overflow", "unset");  
   });


$(document).on('click', '.cstm-header-search-overlay.cstm-header-search-overlay-two', function(){
        $('.ast_headermain').find('.cstm-search-drawer-close').trigger('click');
   });